import { Currency } from "config/constants"
import Address from "./Address"
import Customer, { ICustomerDto } from "./Customer"
import CustomerContact from "./CustomerContact"

export interface ICustomerExtendedDto extends ICustomerDto {
    blocked: boolean
    currency?: Currency | null
    termsOfPaymentCode?: string | null
}

export default class CustomerExtended extends Customer {
    blocked: boolean
    currency?: Currency
    termsOfPaymentCode?: string

    constructor(dto: ICustomerExtendedDto) {
        super(dto)
        this.blocked = dto.blocked
        this.currency = dto.currency || undefined
        this.termsOfPaymentCode = dto.termsOfPaymentCode || undefined
    }

    static fromDto(dto: ICustomerExtendedDto): Customer {
        return new CustomerExtended({
            name: dto.name,
            number: dto.number ?? undefined,
            address: dto.address ? new Address(dto.address) : undefined,
            customerContact: dto.customerContact ? new CustomerContact(dto.customerContact) : undefined,
            blocked: dto.blocked,
            currency: dto.currency || undefined,
            termsOfPaymentCode: dto.termsOfPaymentCode || undefined,
        })
    }

    toDto(): ICustomerExtendedDto | undefined {
        return this.isEmpty() ? undefined : {
            name: this.name,
            number: this.number,
            address: this.address?.toDto(),
            customerContact: this.customerContact?.toDto(),
            blocked: this.blocked,
            currency: this.currency,
            termsOfPaymentCode: this.termsOfPaymentCode,
        }
    }

    get isErpCustomer(): boolean {
        return !!this.number
    }
}
